import React from 'react';
import { Loader2 } from 'lucide-react';

export default function ProgressBar({ current, total, fileName }) {
  if (total === 0) return null;
  const percentage = Math.round((current / total) * 100);

  return (
    <div className="w-full bg-slate-800/50 backdrop-blur-md rounded-xl border border-slate-700/50 p-4 animate-fade-in">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <Loader2 size={16} className="text-indigo-400 animate-spin" />
          <span className="text-sm text-gray-300">
            Converting {current}/{total}
          </span>
        </div>
        <span className="text-sm font-mono text-indigo-400">{percentage}%</span>
      </div>
      <div className="w-full h-2 bg-slate-700 rounded-full overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-indigo-500 to-purple-500 rounded-full transition-all duration-300 ease-out"
          style={{ width: `${percentage}%` }}
        />
      </div>
      <p className="text-xs text-gray-500 mt-1 truncate">{fileName}</p>
    </div>
  );
}
